import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OnlineHero = _resolveComponent("OnlineHero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_PostsBlock = _resolveComponent("PostsBlock")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OnlineHero),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("online.title")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContent, null, {
          default: _withCtx(() => [
            _createVNode("p", null, _toDisplayString(_ctx.$t("online.description")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_PostsBlock),
    _createVNode(_component_FollowFestival)
  ], 64))
}